import e from "clsx";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/Footer/base/FooterLink.tsx
var r = "rounded-xs underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus";
function i(e, t) {
	let n = new Set(t?.split(/\s+/).filter(Boolean));
	return e === "_blank" && (n.add("noopener"), n.add("noreferrer")), n.size > 0 ? Array.from(n).join(" ") : void 0;
}
function a({ linkComponent: a = "a", href: o, target: s, rel: c, icon: l, className: u, children: d, ...f }) {
	return /* @__PURE__ */ n(a, {
		href: o,
		target: s,
		rel: i(s, c),
		className: e(r, l && "inline-flex items-center", u),
		...f,
		children: [d, l ? /* @__PURE__ */ t("span", {
			"aria-hidden": "true",
			className: "ml-2 flex text-xl",
			children: /* @__PURE__ */ t(l, {
				"aria-hidden": "true",
				focusable: "false"
			})
		}) : null]
	});
}
//#endregion
export { r as FOOTER_ANCHOR_CLASS, a as FooterLink, i as mergeRel };
